import * as ActionTypes from './types';

export function getRoles(payload) {
  return {
    type: ActionTypes.GET_ROLES,
    payload: payload
  }
}

export function getRolesSuccess(payload) {
  return {
    type: ActionTypes.GET_ROLES_SUCCESS,
    payload: payload
  }
}

export function getRolesFail(payload) {
  return {
    type: ActionTypes.GET_ROLES_FAIL,
    payload: payload
  }
}



// WEBPACK FOOTER //
// ./src/actions/roles.js